import roundAndReturnString from "../../../../objects/CommonUse/round_and_return_string";

export const addToSavingsTranArr = (tranType, tranAmt, currentGameDate, tranNbr, currentPrice, tranArr ) => {
    tranNbr += 1;
    // adds to tranArr and updates tranNbr
    let actualTranAmt = tranAmt;
    let savingsTranObj = {tranType: tranType, tranDate: currentGameDate, tranNbr: tranNbr.toString(),
            tranAmt: (+tranAmt).toString()}
    if (currentPrice && currentPrice !== 0){
        let quantity = (+tranAmt / +currentPrice);
        quantity = roundAndReturnString(quantity, 4);
        actualTranAmt = (+quantity * +currentPrice).toFixed(2);
        currentPrice = roundAndReturnString(currentPrice, 2);
        savingsTranObj.tranAmt = roundAndReturnString(actualTranAmt, 2);
        savingsTranObj = {...savingsTranObj, shareQuantity: quantity, sharePrice: currentPrice};
    }
    tranArr.push(savingsTranObj);
    return tranNbr;
}
export default addToSavingsTranArr;